<template>
  <div>
    <div class="order-meta d-flex pa-1 pl-0 mb-1">
      <div class="pr-2">
        <span v-if="$vuetify.breakpoint.mdAndUp">Order</span> #{{ value.orderid }}
      </div>
      <v-divider
        class="mx-1"
        vertical
        light
      />
      <div class="px-2">
        {{ datePlaced }}
      </div>
      <div class="order-price flex-grow-1 text-right">
        <span v-if="value.total && value.total * 1 > 0">${{ total }}</span>
      </div>
    </div>
    <v-card
      class="pa-4"
    >
      <div class="px-4 order-status mb-3">
        <div v-if="value.status === 'I'">
          Not Finished
        </div>
        <div v-else-if="value.status === 'Q'">
          Queued
        </div>
        <div v-else-if="value.status === 'P'">
          Processed
        </div>
        <div v-else-if="value.status === 'B'">
          Backordered
        </div>
        <div v-else-if="value.status === 'R'">
          Refunded
        </div>
        <div v-else-if="value.status === 'D'">
          Declined
        </div>
        <div v-else-if="value.status === 'F'">
          Failed
        </div>
        <div v-else-if="value.status === 'C'">
          Complete
        </div>
        <div v-else>
          Pending
        </div>
      </div>

      <v-divider class="my-4" />

      <v-row
        v-if="!items.length && !giftcerts.length"
      >
        <v-col
          cols="12"
        >
          Additional information is currently unavailable for this order.  Please call <a :href="phoneUrl">{{ phone }}</a> for details.
        </v-col>
      </v-row>

      <v-row
        v-else
      >
        <v-col
          cols="12"
          md="6"
          class="py-0 mb-4"
          v-for="(item, index) in giftcerts"
          :key="index"
        >
          <order-giftcert
            :value="item"
            :order="value"
            v-bind="{ type }"
          >
          </order-giftcert>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="py-0 mb-4"
          v-for="(item, index) in items"
          :key="index"
        >
          <order-item
            :value="item"
            :order="value"
            v-bind="{ type }"
          >
          </order-item>
        </v-col>
      </v-row>

      <template
        v-if="trackingNumbers.length"
      >
        <v-divider class="my-4" />
        <div
          v-for="({ number, url }, $index) in trackingNumbers"
          :key="number || $index"
          class="pb-1"
        >
          <v-btn
            text
            small
            color="primary"
            class="mt-1"
            :href="url"
            target="_blank"
          >Tracking #: {{ number || '?' }}</v-btn>
        </div>
      </template>

      <v-divider class="my-4" />

      <div class="text-right">
        <v-btn
          color="primary"
          small
          :href="`/cart.php?mode=order_message&orderids=${value.orderid}`"
          target="_blank"
        >View Details</v-btn>
      </div>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.order-meta {
  line-height: 20px;
  font-weight: bold;
}
.order-price {
  opacity: 0.6;
}
.order-status {
  opacity: 0.7;
  font-size: 20px;
  line-height: 20px;
}
</style>

<script>
import OrderItem from './OrderItem'
import OrderGiftcert from './OrderGiftcert'
import { XConfig } from '@/models'
import trackingUrl from 'tracking-url'

export default {
  components: {
    OrderGiftcert,
    OrderItem
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: null
    }
  },
  computed: {
    datePlaced () {
      if (!(this.value && this.value.date)) {
        return 'Not Available'
      }
      return this.$timestamp(this.value.date)
    },
    items () {
      const detailRecords = this.value?.order_detail_records || []
      if (this.type === 'returns') {
        return detailRecords.filter(r => r.amount_refunded > 0)
      }
      return detailRecords
    },
    giftcerts () {
      return this.value?.giftcert_records || []
    },
    itemCount () {
      return this.giftcerts.length + this.items.reduce((acc, orderDetail) => {
        return (orderDetail.amount * 1) + (acc * 1)
      }, 0)
    },
    phone () {
      const phoneConfig = XConfig.find('company_phone')
      return phoneConfig.value
    },
    phoneUrl () {
      if (this.phone) {
        return `tel://${this.phone}`
      }
      return null
    },
    trackingNumbers () {
      return (this.value?.shipment_records || [])
        .filter(record => !!record.tracking)
        .map(record => {
          const result = {
            number: record.tracking,
            ...trackingUrl(record.tracking)
          }
          result.url = result.url || 'https://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?trackingNumber=' + result.number
          return result
        })
    },
    total () {
      return this.value?.usd_exchange_rate > 0 ? this.value?.total + ' CAD ($' + this.value?.usd_total + ' USD)' : this.value?.total
    }
  }
}
</script>
